// import * as Sentry from '@sentry/nextjs';
import assign from 'lodash/assign';
import isString from 'lodash/isString';
import PopupLogin from 'client/widgets/functions/popup-login';
import { UiToast, UiModal } from 'components';
import fetchJsonp from 'fetch-jsonp';
import { globalStore } from 'stores';
import { UserInfo, QdInfo } from 'types/user';
import { appClient, base, browser } from 'lib';
import { user, api, amber } from '../request';
import { formatStr, reload, formatTime } from '../utils';
import { create } from '../debug';
import storage from '../storage';
import channel from '../channel';
import flintConfig from '../flint-config';
import deepLink from '../deep-link';
import sdata from '../sdata';

import { getRichLevel as _getRichLevel } from '../level';

import refreshToken from './refresh-token';

import severTime from './server-time';
import track from '../track';
import messenger from '../messenger';

const log = create('user');
const error = create('user:error');

let userInfo: UserInfo | null = null;
let token = '';
let refreshTokenInfo = {};
// let token = '8fd881ba9cc14b80ea06032d3ebd8090';
const loginTime = null;
let qd = '';
let childQd = '';
let dynamicQd = '';
let _isFirstCharge = true;

const USER_TOKEN = 'ACCESS_TOKEN';
const LOGIN_TIME = 'USER_LOGIN_TIME';
const OPEN_ID = 'USER_OPEN_ID';
const USER_INFO = 'TTSHOW_USER_INFO';
const QD_INFO = 'QD_INFO';
const FIRST_CHARGE = 'FIRST_CHARGE';

const init = async (query, callback?) => {
  log('用户模块初始化');
  await refreshToken.init();

  MM.user.init();
  MM.user.popupRegister = popupRegister;
  MM.user.popupLogin = popupLogin;

  flintConfig.init();

  severTime.init();
  track.init();
  messenger.init();

  // if (!config.production) {
  //     const VConsole = require('vconsole');
  //     let vConsole = new VConsole();
  // }

  // log('init query', query);

  if (query.access_token && query.access_token !== 'null') {
    saveToken(query.access_token);
  }
  getToken();
  userInfo = storage.getItem(USER_INFO);

  log('token', getToken());

  const qdInfo: QdInfo = storage.getItem(QD_INFO);
  if (qdInfo) {
    qd = qdInfo.qd;
    childQd = qdInfo.childQd;
    dynamicQd = qdInfo.dynamicQd;
  }

  // 兼容 渠道ID 问题
  if (query.from || query.union || query.union_id || query.dynamic_qd) {
    qd = query.from || query.union || query.union_id || query.dynamic_qd;
    // if (!/_h5$/gi.test(qd)) {
    //   qd += '_h5';
    // }
  }
  if (query.dynamic_qd) {
    dynamicQd = query.dynamic_qd;
  }
  if (query.sid || query.union_sid || query.union_cid) {
    childQd = query.sid || query.union_sid || query.union_cid;
  }

  if (query.auto) {
    deepLink.linkHome();
  }

  // 保存渠道信息
  storage.setItem(QD_INFO, getQdInfo());
  channel.init();
  sdata.init();

  // 判断已经登录
  if (isLogin()) {
    loadUserInfo((userInfo) => {
      track.sendPageView();
      sdata.login(userInfo._id);
      MM.user.kefu.init();

      // v2项目中获取到的token，需要同步到v1中
      if (!MM.user.getToken()) {
        MM.user.setUserOriginToken(getToken());
        MM.user.init();
        MM.fixedbar.main.init();
      }

      callback && callback(userInfo);
    }, true);
  } else {
    globalStore.setUserInfoReady();
    track.sendPageView();
    // sdata.init();
    callback && callback();
  }
};

const isLogin = () => {
  return !!getToken() && !!userInfo;
};

const getUserInfo = () => {
  if (!isLogin()) {
    return null;
  }
  return userInfo;
};
const getUserId = () => {
  if (!isLogin() || !userInfo) {
    return '';
  }
  return userInfo._id;
};

const loadUserInfo = (cb, isLoginLoad = false) => {
  api
    .get('user/info/{access_token}', {
      qd,
      child_qd: childQd,
    })
    .then((res: any) => {
      userInfo = res.data;
      userInfo = assign(
        {
          finance: {
            bean_count: 0,
            bean_count_total: 0,
            coin_count: 0,
            coin_spend_total: 0,
            profit: 0, // 收益余额 单位：分
            profit_total: 0, // 总收益
            benefit_total: 0, // 主播经验值，对应流水，用于计算新的 主播等级
          },
          enter_info_bg: 1,
          m_vip: 0,
          vip: 0,
        },
        userInfo,
      );

      log('getUserInfo', userInfo);

      storage.setItem(USER_INFO, userInfo);

      // Sentry.configureScope(function (scope) {
      //   scope.setUser({
      //     id: userInfo!._id + '',
      //     username: userInfo!.nick_name,
      //   });
      // });

      globalStore.setUserInfo(userInfo);
      MM.user.setUserInfo(userInfo);
      // appStore.userInfo = userInfo;
      // appStore.isLogin = true;
      // PopupLogin.close()

      // initFirstCharge();

      if (isLoginLoad) {
        sendLoginLog();
      }
      // qd = userInfo.qd;
      cb && cb(userInfo);
    })
    .catch((res) => {
      error('loadUserInfo', res);
      if (res && (res.code || res.msg)) {
        // let tips = {
        //   30405: 'Token 已失效'
        // }
        if (res?.code === 30405) {
          clearUserInfo();
        }

        // console.log('token =>',)

        UiToast.fail(res.msg, reload);
      }
    });
};

const saveToken = (tokenStr: string) => {
  token = tokenStr;
  storage.setItem(USER_TOKEN, token);
  MM.user.setUserOriginToken(token);
};

const saveOpenId = (openid) => {
  storage.setItem(OPEN_ID, openid);
};
const getOpenId = () => {
  return storage.getItem(OPEN_ID);
};

const getToken = () => {
  // todo: 临时老版本库文件中获取
  if (typeof window !== 'undefined') {
    token = MM.user.getToken() || token || storage.getItem(USER_TOKEN) || '';
  }
  return token;
};

let isSentLog = false;
const sendLoginLog = () => {
  if (isSentLog) {
    return;
  }
  isSentLog = true;

  let loginDate = storage.getItem(LOGIN_TIME);
  const today = formatTime(Date.now(), 'yyyyMMdd');
  if (!loginDate || today !== loginDate) {
    api.get('user/day_login/{access_token}?p=3').then((res) => {
      loginDate = today;
      storage.setItem(LOGIN_TIME, today);
    });

    // fetchJsonp(
    //   'https://api.map.baidu.com/location/ip?ak=aqMigZp0k9MclnwAgoQNeiSA2HgI2IZi&coor=bd09ll',
    // )
    //   .then((res) => {
    //     return res.json();
    //   })
    //   .then((res) => {
    //     const point = res.content.point;
    //     sdata.track('longitude_latitude_log', {
    //       longitude_x: parseFloat(point.x),
    //       longitude_y: parseFloat(point.y),
    //     });
    //   })
    //   .catch((res) => {
    //     // UiToast.fail('位置获取失败');
    //   });
  }
};

const getQdInfo = (): QdInfo => {
  const name = qd.replace(/_h5$/gi, '');
  return {
    name,
    h5Qd: `${qd}_h5`,
    qd,
    childQd,
    dynamicQd,
    androidQd: `${name}_android`,
    iosQd: `${name}_ios`,
  };
};

/**
 * 设置渠道名
 * @param name
 */
const setQdName = (name) => {
  qd = name;
};

const clearUserInfo = () => {
  track.send({
    event: 'user',
    event_type: 'clearUserInfo',
    content: {},
  });
  token = '';
  userInfo = null;
  refreshToken.clear();
  globalStore.setUserInfo(userInfo);

  // appStore.userInfo = null;
  // appStore.isLogin = false;
  storage.remove(USER_TOKEN);
  MM.user.clearUserInfo();
};

const logout = (pathname = '/') => {
  sdata.logout();

  track.send({
    event: 'user',
    event_type: 'logout',
    content: {},
  });

  clearUserInfo();
  // Router.push('/')

  if (!isString(pathname)) {
    pathname = '/';
  }

  if (browser.memeClient) {
    appClient.redirectLogin();
    appClient.closeWindow();
    return;
  }

  reload({
    pathname,
    tip: '正在退出么么',
  });
  log('logout', getToken());
};

const popupLogin = (options = {}) => {
  if (browser.memeClient) {
    appClient.redirectLogin();
    appClient.closeWindow();
  } else if (window.inPcClient) {
    PopupLogin.show();
  } else {
    PopupLogin.show();
    // MM.user.popupLogin();
  }
  // MM.user.popupLogin()
  // PopupAccountLogin.show();
  // PopupLogin.show(options);
  // Modal.alert('', '您还未登录', () => {
  //     redirectLogin()
  // }, '去登录')
};

const popupRegister = () => {
  // MM.user.popupRegister();
  PopupLogin.show({ isRegister: true });
};

const afterLogin = (cb) => {
  if (isLogin()) {
    cb && cb();
  } else {
    popupLogin();
  }
};

const getRichLevel = () => {
  if (isLogin()) {
    return _getRichLevel(userInfo!.finance.coin_spend_total).level;
  }
  return 0;
};

// 是否是自己
const isSelf = (_id) => {
  return isLogin() ? userInfo!._id === parseInt(_id, 10) : false;
};

/**
 * 是否关联手机号
 */
const isCompleteMobileBind = () => {
  return !!(userInfo && userInfo.detail_info && userInfo.detail_info.mobile_bind);
};
/**
 * 是否绑定手机号
 * 绑定信息通过接口 MM.core.getRoot('show?access_token={access_token}', 'user')
 */
const isMobileBind = () => {
  return userInfo && userInfo.mobile_bind;
};

const initFirstCharge = () => {
  const data = storage.getItem(FIRST_CHARGE) || {};
  if (data[getUserId()] === false) {
    _isFirstCharge = false;
    return;
  }
  api.get('user/first_charge?access_token={access_token}').then((res: any) => {
    _isFirstCharge = res.data.flag;
    data[getUserId()] = _isFirstCharge;
    storage.setItem(FIRST_CHARGE, data);
  });
};

/**
 * 是否是 首充
 * @returns {boolean}
 */
const isFirstCharge = () => {
  return _isFirstCharge;
};

const isVip = () => {
  return 0;
  // if (isLogin()) {
  //   return userInfo && userInfo.vip && userInfo.vip > 0
  // } else {
  //   return 0
  // }
};

/**
 * 支付弹窗
 */
const showPayPopup = (coin = 1000) => {
  redirectPay();
};

type RedirectPayParams = {
  currentTarget?: any;
};

/**
 * 跳转到支付页面
 * @params {
 *     coin:   需要充值的柠檬
 *     ...
 * }
 */
const redirectPay = (params: RedirectPayParams = {}) => {
  UiModal.alert({
    title: '提示',
    content: `
        <div>网页端充值功能已下线 </div>
        <div>如需充值，敬请通过“么么直播”手机APP或微信公众号进行操作</div>
`,
    cancelEnable: false,
  });
  // log('redirectPay params:', params);
  // afterLogin(() => {
  //   window.open('/pay.html');
  // });
};

// 1:运营 2:主播 3:普通用户 4:客服 5:代理
const isStar = () => {
  return !!userInfo && userInfo.priv === 2;
};

const isOperate = () => {
  return !!userInfo && userInfo.priv === 1;
};

const isService = () => {
  return !!userInfo && userInfo.priv === 4;
};

const expired = () => {
  track.send({
    event: 'user',
    event_type: 'expired',
    content: {},
  });
  UiToast.info('您的身份已经过期，请重新登录', () => {
    clearUserInfo();

    if (window.inPcClient) {
      logout();
    } else {
      reload();
    }
  });
};

const showNoMoney = () => {
  UiModal.alert({
    title: '提示',
    content: '余额不足，请充值',
    onOk: (e) => {
      redirectPay();
      return true;
    },
    cancelEnable: false,
    okText: '充值',
  });
  // UiToast.fail(
  //   <div>
  //     余额不足，请充值
  //     <a href="/pay" target="_blank" className="btn btn-primary">充值</a>
  //     </div>
  // )
};

const destroy = () => {
  messenger.destroy();
};

export default {
  getToken,
  saveToken,
  saveOpenId,
  getOpenId,
  getUserInfo,
  getUserId,
  loadUserInfo,
  isLogin,
  clearUserInfo,
  logout,
  expired,
  showNoMoney,

  getQdInfo,
  setQdName,
  init,
  popupLogin,
  popupRegister,
  afterLogin,
  getRichLevel,
  isSelf,
  isService,
  isCompleteMobileBind,
  isMobileBind,
  isFirstCharge,
  isVip,
  redirectPay,
  showPayPopup,
  isStar,
  isOperate,

  destroy,
};
